/**
 * BDD Scenarios — list of Gherkin scenarios with pass/fail/pending status.
 *
 * CSS: styles/components/bdd.css
 */

import { esc } from '../../shared/rendering.js'
import { action } from './action-delegation.js'
import type { BDDScenariosProps } from '../../types/components.js'

/** Render the BDD scenarios section. */
export function renderBDDScenarios(props: BDDScenariosProps): string {
  const total = props.scenarios.length
  const passed = props.scenarios.filter((s) => s.status === 'pass').length
  const failed = props.scenarios.filter((s) => s.status === 'fail').length

  const scenariosHtml = props.scenarios
    .map((scenario) => {
      const stepsHtml = scenario.steps
        .map(
          (step) =>
            `<div class="bdd-step"><span class="bdd-kw">${esc(step.keyword)}</span> ${esc(step.text)}</div>`,
        )
        .join('')

      return `<div class="bdd-s">
      <div class="bdd-sh" role="button" tabindex="0" aria-expanded="false" ${action('toggleBddScenario')}>
        <span class="bdd-vd ${scenario.status}">${esc(scenario.status)}</span>
        <span class="bdd-n">${esc(scenario.name)}</span>
        <span class="bdd-x">&#9654;</span>
      </div>
      <div class="bdd-steps">${stepsHtml}</div>
    </div>`
    })
    .join('')

  return `<div>
    <div class="bdd-bar">
      <div class="bdd-t">BDD Scenarios <span class="bdd-cnt">${total}</span></div>
      <div class="bdd-acts">
        <span style="font-size:9px;color:var(--t3)">${passed} pass &middot; ${failed} fail</span>
      </div>
    </div>
    <div class="bdd-list">${scenariosHtml}</div>
  </div>`
}
